export default __webpack_public_path__ + "static/media/logo-black.e58d1b09.svg";